import ReactGA from "react-ga4";

import { CplEventAction } from "../utils";

import {
  GA_CPL_BID_FIXED_DECIMALS,
  GA_CPL_BID_MULTIPLIER,
} from "./ga-tracker.constants";
import {
  GaEvent,
  GaEventCategories,
  GaSweepstakesEventActions,
} from "./ga-tracker.types";

export function useGaCplEventTracker(): (
  label: string,
  action: CplEventAction,
  value?: number | null
) => void {
  return (
    label: string,
    action: CplEventAction,
    value?: number | null
  ) => {
    const cplTrackEventObject: GaEvent = {
      category: GaEventCategories.CPL,
      action,
      label,
      value:
        value && Number(value)
          ? Number(Number(value).toFixed(GA_CPL_BID_FIXED_DECIMALS)) *
            GA_CPL_BID_MULTIPLIER
          : undefined,
      nonInteraction: action === CplEventAction.IMPRESSION,
    };
    try {
      ReactGA.event(cplTrackEventObject);
    } catch (error) {
      console.error(error);
    }
  };
}

export function useGaSweepstakesEventTracker(): (
  action: GaSweepstakesEventActions
) => void {
  return (action: GaSweepstakesEventActions) => {
    const sweepstakesTrackEventObject: GaEvent = {
      category: GaEventCategories.SWEEPSTAKES,
      action,
    };
    try {
      ReactGA.event(sweepstakesTrackEventObject);
    } catch (error) {
      console.error(error);
    }
  };
}
